import React from 'react';
import PropTypes from 'prop-types';
import BsModal from 'react-bootstrap/Modal';
import { FaExclamationTriangle, FaQuestionCircle } from 'react-icons/fa';
import Button from './Button';

const TONE_ICONS = { danger: FaExclamationTriangle, accent: FaQuestionCircle };
const TONE_TILE_CLASSES = {
	danger: 'tw:bg-danger-soft tw:text-danger',
	accent: 'tw:bg-accent-soft tw:text-accent',
};

/**
 * Shared confirm/cancel dialog using the same header/body/footer chrome as
 * ExportModal (icon tile + title + description, footer with two buttons).
 * For a yes/no confirmation with the polished look — not a replacement for
 * the legacy components/ConfirmationModal, which existing callers keep using.
 */
function ConfirmDialog({
	show,
	onClose,
	onConfirm,
	title,
	description,
	confirmCaption = 'Confirmar',
	cancelCaption = 'Cancelar',
	tone = 'accent',
}) {
	const Icon = TONE_ICONS[tone] || TONE_ICONS.accent;

	return (
		<BsModal
			show={show}
			onHide={onClose}
			centered
			dialogClassName='tw:max-w-[440px]'
			contentClassName='entity-list-page el-modal tw:rounded-[14px] tw:border-0 tw:overflow-hidden tw:shadow-overlay tw:font-sans tw:text-[14px]/[1.45] tw:text-ink-0'
		>
			<BsModal.Header
				closeButton
				className='tw:items-start tw:border-b tw:border-border tw:px-[22px] tw:pt-[20px] tw:pb-[14px]'
			>
				<div className='tw:flex tw:items-start tw:gap-3'>
					<span className={`tw:mt-0.5 tw:flex tw:h-[38px] tw:w-[38px] tw:shrink-0 tw:items-center tw:justify-center tw:rounded-[9px] ${TONE_TILE_CLASSES[tone] || TONE_TILE_CLASSES.accent}`}>
						<Icon />
					</span>
					<div>
						<BsModal.Title className='tw:text-[17px]/[1.3] tw:font-bold tw:tracking-[-0.01em] tw:text-ink-0'>
							{title}
						</BsModal.Title>
						{description && <p className='tw:mb-0 tw:mt-1 tw:text-[12.5px] tw:text-ink-2'>{description}</p>}
					</div>
				</div>
			</BsModal.Header>

			<BsModal.Footer className='tw:border-t tw:border-border tw:bg-surface-2 tw:px-[22px] tw:py-[14px] tw:gap-2'>
				<Button variant='default' onClick={onClose}>
					{cancelCaption}
				</Button>
				<Button variant='primary' onClick={onConfirm}>
					{confirmCaption}
				</Button>
			</BsModal.Footer>
		</BsModal>
	);
}

ConfirmDialog.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	title: PropTypes.node.isRequired,
	description: PropTypes.node,
	confirmCaption: PropTypes.string,
	cancelCaption: PropTypes.string,
	tone: PropTypes.oneOf(['danger', 'accent']),
};

export default ConfirmDialog;
